import React from 'react';
import PropTypes from 'prop-types';

import InternalBrokers from 'bundles/apex/deals/form/fields/internal_brokers';
import OutsideBrokers from 'bundles/apex/deals/form/fields/outside_brokers';
import TransactionSide from 'bundles/apex/deals/form/fields/transaction_side_totals';
import { getTransactionSideLabel } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';
import { getTransactionSideOptionLabels } from 'bundles/apex/deals/helpers/labels';

export default function TransactionSideSubsection({ deal, transactionSide }) {
  if (!deal.dealType || !deal.stage) {
    return null;
  }

  const transactionSideOptions = getTransactionSideOptionLabels(deal.dealType);
  const label = getTransactionSideLabel(transactionSide, transactionSideOptions);

  return <>
    <h6 className="fs-large">{label}</h6>
    <section className="mb-4">
      <TransactionSide className="mb-4" deal={deal} transactionSide={transactionSide} />

      <div className="fw-bold">Outside Brokers</div>
      <OutsideBrokers transactionSide={transactionSide} />

      <div className="fw-bold">Internal Brokers</div>
      <InternalBrokers transactionSide={transactionSide} />
    </section>
  </>;
}

TransactionSideSubsection.propTypes = {
  deal: PropTypes.shape({
    transactionSideDetails: PropTypes.arrayOf(PropTypes.shape({
      grossAmount: PropTypes.number.isRequired,
      grossPercent: PropTypes.number.isRequired,
      transactionSide: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  transactionSide: PropTypes.string.isRequired,
};
